import React, { useState } from "react";
import { Button, Card, Col, Row } from "reactstrap";
import { connect } from "react-redux"; 
import CustomModal from "../../../../../Components/Modals/CustomModal";
import FetchStoreUserRoleMappingDataService from "../../../../../../Service/OPSServices/AccountDetailsService/FetchStoreUserRoleMappingDataService";
import SWTeamRolesCard from "../Account Details/Component/SubComponents/SWTeamRolesCard";

function WorkflowsMenuSectionKickoff(props) {
  const [swTeamRolesPopup, setSwTeamRolesPopup] = useState(false);
  const [mappingTable, setMappingTable] = useState([]);
  const [memberDropdown, setMemberDropdown] = useState([]);
  
  const handleRoleSettingPopup = () => {
    let data = { id: 0, integerId: props.selectedStore };
    FetchStoreUserRoleMappingDataService(props.token, data).then((res) => {
      if (res) {
        setSwTeamRolesPopup(true);
        setMappingTable(res.tableData);
        setMemberDropdown(res.memberDropdown);
      }
    });
  };


  return (
    <Col md={12}>
      <Card
        className={
          props.isMyworksScreen ? "d-none" : "p-4 card-of-problemarea"
        }
      >
        <Row>
          <Col md={12}>
            <div className="d-flex position-relative">
              
              <select
                id="StoreList"
                value={props.selectedStore || ""}
                onChange={props.handleStoreChange}
                className="form-control w-25"
              >
                <option value="">--Select Store--</option>
                {props.adProfiles &&
                  props.adProfiles.map((store) => (
                    <option key={store.integerID} value={store.integerID}>
                      {store.name}
                    </option>
                  ))}
              </select>

              <select
                value={props.selectedWorkflowMasterId || ""}
                onChange={(e) => props.handleWorkflowMaster(e.target.value)}
                className="form-control ml-5 w-25"
              >
                <option value="">--Select Workflow--</option>
                {props.workflowMainCategory &&
                  props.workflowMainCategory.map((wf) => (
                    <option
                      key={wf.id}
                      value={wf.id}
                      disabled={!props.selectedStore || !props.selectedStoreData}
                    >
                      {wf.name}
                    </option>
                  ))}
              </select>

              <Button
                className="btn-background-color ml-5"
                onClick={props.handleSubmitWorkflow}
                disabled={
                  !props.selectedWorkflowMasterId || !props.selectedStoreData
                }
              >
                Submit
              </Button>

              {/* SW Team Roles Button */}
              <Button
                className="btn-background-color ml-3"
                onClick={handleRoleSettingPopup}
                disabled={!props.selectedStore}
              >
                SW Team Roles
              </Button>
              
            </div>
          </Col>
        </Row>
      </Card>

      {/* SW Team Roles Modal */}
      <CustomModal
        header={
          props.selectedStore && props.adProfiles
            ? (() => {
                const matchedStore = props.adProfiles.find(
                  (store) => String(store.integerID) === String(props.selectedStore)
                );
                return matchedStore ? `SW Team Roles : ${matchedStore.name}` : "SW Team Roles";
              })()
            : "SW Team Roles"
        }
        isOpen={swTeamRolesPopup}
        toggle={() => setSwTeamRolesPopup(!swTeamRolesPopup)}
        size={"lg"}
        className="curve-popup my-task-custom-module"
      >
        <SWTeamRolesCard
          mappingTable={mappingTable}
          setMappingTable={setMappingTable}
          setMemberDropdown={setMemberDropdown}
          memberDropdown={memberDropdown}
          isModal={true}
        />
      </CustomModal>
    </Col>
  );
}

const mapStateToProps = (state) => {
  return {
    token: state.loggedUser.token,
    adProfiles: state.accountOverview.landing.adProfiles,
  };
};

export default connect(mapStateToProps)(WorkflowsMenuSectionKickoff);